import { createClient, type SupabaseClient } from '@supabase/supabase-js';

let browserClient: ReturnType<typeof createClient> | null = null;
let authenticatedBrowserClient: SupabaseClient | null = null;
let authenticatedAccessToken: string | null = null;

export function hasSupabaseEnv(): boolean {
  return Boolean(
    process.env.NEXT_PUBLIC_SUPABASE_URL?.trim() &&
      process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY?.trim()
  );
}

export function getSupabaseBrowserClient(): SupabaseClient | null {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL?.trim();
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY?.trim();

  if (!supabaseUrl || !supabaseAnonKey) {
    return null;
  }

  if (!browserClient) {
    browserClient = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: false,
        detectSessionInUrl: false,
        persistSession: false,
      },
    });
  }

  return browserClient;
}

export function getAuthenticatedBrowserClient(token: string): SupabaseClient | null {
  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL?.trim();
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY?.trim();
  const accessToken = token.trim();

  if (!supabaseUrl || !supabaseAnonKey || !accessToken) {
    authenticatedAccessToken = null;
    return null;
  }

  authenticatedAccessToken = accessToken;

  if (!authenticatedBrowserClient) {
    authenticatedBrowserClient = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: false,
        detectSessionInUrl: false,
        persistSession: false,
      },
      accessToken: async () => authenticatedAccessToken,
    });
  } else {
    authenticatedBrowserClient.realtime.setAuth(accessToken);
  }

  return authenticatedBrowserClient;
}
